<template>

    <div id="layout-open" class="layout">
        <v-the-alerts />
        <v-the-cookie-banner />
        <transition name="modal">
            <v-modal-cookie-preferences v-if="modal === 'cookie-preferences'" />
        </transition>
        <main class="layout-body">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>
    </div>

</template>

<style scoped lang="scss">

    .layout {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        .layout-body {
            flex-grow: 1;
        }
    }

</style>

<script>

import ModalCookiePreferences from '@modals/ModalCookiePreferences';
import TheAlerts from '@cmp/TheAlerts';
import TheCookieBanner from '@cmp/TheCookieBanner';

export default {

    components: {
        'v-modal-cookie-preferences': ModalCookiePreferences,
        'v-the-alerts': TheAlerts,
        'v-the-cookie-banner': TheCookieBanner,
    },

    computed: {

        modal() {
            return this.$store.getters.modal;
        },

    },

    beforeCreate() {
        // Public pages are always light, even if a signed-in session prefers dark mode.
        document.documentElement.classList.remove('dark-mode');
        if (!localStorage.getItem('lang')) {
            this.$store.commit('setTempLang');
        }
    },

}

</script>